<div class="filter" ngModelGroup="stopDetailsGroup" #stopDetails="ngModelGroup">

  <app-filter-item [title]="'Reason for Stop'" [value]="reasonForStopValue" [clearFilter]="clearFilter('reasonForStop')">
    <mat-form-field appearance="outline" class="filter__select_full">
      <mat-select multiple
        name="reasonForStop"
        placeholder="Reason for Stop"
        [(ngModel)]="stopDetailsGroup.reasonForStop"
      >
        <mat-option *ngFor="let item of reasonForStopOptions" [value]="item.value">
          {{item.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </app-filter-item>

  <app-filter-item [title]="'Reason for Search'" [value]="reasonForSearchValue" [clearFilter]="clearFilter('reasonForSearch')">
    <mat-form-field appearance="outline" class="filter__select_full">
      <mat-select multiple
        name="reasonForSearch"
        placeholder="Reason for Search"
        [(ngModel)]="stopDetailsGroup.reasonForSearch"
      >
        <mat-option *ngFor="let item of reasonForSearchOptions" [value]="item.value">
          {{item.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </app-filter-item>

  <app-filter-item [title]="'Contraband or Evidence Discovered'"
    [value]="contrabandOrEvidenceValue"
    [clearFilter]="clearFilter('contrabandOrEvidence')"
  >
    <mat-form-field appearance="outline" class="filter__select_full">
      <mat-select multiple
        name="contrabandOrEvidence"
        placeholder="Contraband or Evidence Discovered"
        [(ngModel)]="stopDetailsGroup.contrabandOrEvidence"
      >
        <mat-option *ngFor="let item of contrabandOrEvidenceOptions" [value]="item.value">
          {{item.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </app-filter-item>

  <app-filter-item [title]="'Result of the Stop'" [value]="resultOfStopValue" [clearFilter]="clearFilter('resultOfStop')">
    <mat-form-field appearance="outline" class="filter__select_full">
      <mat-select multiple
        name="resultOfStop"
        placeholder="Result of the Stop"
        [(ngModel)]="stopDetailsGroup.resultOfStop"
      >
        <mat-option *ngFor="let item of resultOfStopOptions" [value]="item.value">
          {{item.label}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </app-filter-item>

</div>
